import React from 'react';
import { motion } from 'framer-motion';
import { Pizza, Droplets, Users, Clock, Euro } from 'lucide-react';
import { Star, Circle, Triangle } from './MemphisShapes';

const features = [
{
  icon: Pizza,
  title: "GRANDE",
  description: "Pizza generosa, per chi ha fame vera"
},
{
  icon: Clock,
  title: "CROCCANTE",
  description: "Sottile e croccante, come deve essere"
},
{
  icon: Euro,
  title: "ACCESSIBILE",
  description: "Prezzi giusti per tutti"
},
{
  icon: Droplets,
  title: "FREE REFILL",
  description: "Bibite illimitate a 4€"
},
{
  icon: Users,
  title: "PER TUTTI",
  description: "Perfetta per amici e famiglie"
}];


const Concept = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0 }
  };

  return (
    <section
      id="concept"
      data-testid="concept-section"
      className="min-h-screen bg-white py-16 md:py-24 relative overflow-hidden">

      {/* Decorative shapes */}
      <Star className="absolute top-20 right-10 hidden md:block" color="#FFD600" size={50} />
      <Circle className="absolute bottom-32 left-8 hidden md:block" color="#FF2A2A" size={40} />
      <Triangle className="absolute top-40 left-16 hidden md:block" color="#00E5FF" size={35} />

      <div className="max-w-6xl mx-auto px-4 md:px-8">
        {/* Section Title */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12 md:mb-16">

          <h2
            className="font-fredoka font-bold text-4xl sm:text-5xl md:text-6xl lg:text-7xl text-black uppercase mb-4"
            data-testid="concept-title">

            PIZZA SOTTILE
            <br />
            <span className="text-santomato-red">e SMASH BURGER</span>
          </h2>
          <p className="font-nunito text-lg md:text-xl text-gray-700 max-w-2xl mx-auto">
            Qui si mangia bene, si spende giusto, si sta insieme.
          </p>
        </motion.div>

        {/* Features Grid */}
        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6">

          {features.map((feature, index) =>
          <motion.div
            key={index}
            variants={itemVariants}
            whileHover={{ scale: 1.05, y: -5 }}
            className="card-brutal bg-santomato-yellow p-6 text-center"
            data-testid={`concept-feature-${index}`}>

              <div className="bg-black rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4">
                <feature.icon size={32} className="text-santomato-yellow" />
              </div>
              <h3 className="font-fredoka font-bold text-xl md:text-2xl text-black mb-2 uppercase">
                {feature.title}
              </h3>
              <p className="font-nunito text-sm md:text-base text-gray-800">
                {feature.description}
              </p>
            </motion.div>
          )}
        </motion.div>

        {/* Story paragraph */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.3, duration: 0.6 }}
          className="mt-12 md:mt-16 text-center">

          <div className="card-brutal bg-santomato-cream p-6 md:p-10 max-w-3xl mx-auto">
            <p className="font-nunito text-lg md:text-xl text-black leading-relaxed">
              Dal <strong>1985</strong> amiamo la pizza come una volta: <strong>grande</strong>, <strong>sottile</strong> e <strong>croccante</strong>. Niente fronzoli, niente complicazioni. Solo ingredienti buoni, porzioni generose e un'atmosfera dove tornare è sempre una festa.
            

            </p>
          </div>
        </motion.div>
      </div>
    </section>);

};

export default Concept;